export enum GeometryTypes {
    Point = "Point",
    MultiPoint = "MultiPoint",
    LineString = "LineString",
    MultiLineString = "MultiLineString",
    Polygon = "Polygon",
    MultiPolygon = "MultiPolygon",
    GeometryCollection = "GeometryCollection"
  }

export enum AreaTypes {
    Municipality = 0,
    Province = 1,
    Country = 2
  }

export enum MarkerColors {
    DarkBlue = "002C74",
    Blue = "0058B1",
    LightBlue = "008DE3",
    Turquoise = "026273",
    LightTurquoise = "00A2A5",
    Green = "056805",
    Purple = "820084",
    DarkRed = "9E003B",
    Red = "E90008",
    Pink = "C50084",
    Grey = "555555"
  }

export enum TimeOfDay {
    Daytime = 1,
    Evening = 2,
    Night = 3
}
